import { string } from "./../types/string";
import * as validate from "./../utils/validate-inputs";

/**
 * Logs a warning to the console
 *
 * @param {Object:App} object - The app object
 * @param {String} message - The warning message to be logged in the console
 */
export default function feedback(object, message) {
  if (!validate.app(object)) {
    throw Error(validate.error.command);
  }

  message = string(message);
  throw new CodeBlockWarning(message);
}

class CodeBlockWarning extends Error {
  constructor(message) {
    super(message);
    this.name = "CodeBlockWarning";
  }
}
